import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomeService } from '../services/home.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-banner-popup',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './banner-popup.component.html',
  styleUrl: './banner-popup.component.scss'
})
export class BannerPopupComponent {

  url_s3 = environment.URL_S3;
  statusPopup = false;
  dataPopup: any;

  constructor(private router :Router, private homeService: HomeService){}

  ngOnInit(): void {
     this.getBannerPopup();
  
    }

    getBannerPopup(){
    this.homeService.getBannerPopup().subscribe((response: any) => {
      
      
      if (response.rowCount != 0) {

        const randomIndex = Math.floor(Math.random() * response.data.length);
        this.dataPopup =  response.data[randomIndex];
        this.statusPopup= true;
        
      } else {
        this.statusPopup= false;
        this.dataPopup = null;
      }
      // this.dataSliderHome = response.data
      // this.datosCargados.set(true); // Activas la señal
    });
  }


  cerrar() {
    this.statusPopup= false;
    this.dataPopup = null;
  }


}
